<template>
  <div>
    <!-- BreadCrumb -->
    <BreadCrumb v-if="breadcrumbPaths.length > 0" :BreadcrumbPaths="breadcrumbPaths" />

    <!-- SPLASHES (for Home) -->
    <v-row v-if="!!this.$slots.splashes" no-gutters>
      <v-col cols="12" class="pa-0" style="border-bottom: 1px solid var(--v-navlink-base);">
        <slot name="splashes" />
      </v-col>
    </v-row>
    
    <!-- SPLASHES (for other pages) -->
    <v-row v-if="!!this.$slots.hero" no-gutters>
      <v-col cols="12" class="pa-0">
        <slot name="hero" />
      </v-col>
    </v-row>

    <!-- Title -->
    <v-row
      v-if="!!this.$slots.topLeft || !!this.$slots.title"
      :class="$vuetify.breakpoint.mdAndDown && !this.$slots.leftPanel ? 'justify-center' : ''"
      no-gutters
    >
      <v-col 
        v-if="($vuetify.breakpoint.lgAndUp || !!this.$slots.leftPanel || !!this.$slots.topLeft) && !$vuetify.breakpoint.smAndDown"
        cols="12" md="3" lg="2"
        class="pl-4 pt-5 white"
      >
        <slot name="topLeft" />
      </v-col>
      <v-col
        cols="12" md="9" :lg="wideMainPanel ? 10 : 7" 
        :class="wideMainPanel? 'px-6 pt-6 white':'px-6 pt-6 pb-5 white d-flex justify-md-center'"
      >
        <v-sheet max-width="850px" width="100%">
            <slot name="title" />
        </v-sheet>
      </v-col>
      <v-col
        v-if="!!this.$slots.rightPanel && $vuetify.breakpoint.lgAndUp"
        cols="12" md="12" lg="3"
        class="rsidebg px-7 d-flex hidden-md-and-down"
      /><!--SPACER-->
    </v-row>

    <v-row
      no-gutters
      class="d-flex"
      :class="$vuetify.breakpoint.mdAndDown ? 'justify-center' : ''"
    >
      <!--LEFT PANEL-->
      <v-col id="lside"
        v-if="$vuetify.breakpoint.lgAndUp || !!this.$slots.leftPanel || !!this.$slots.topLeft"
        cols="12" md="3" lg="2" 
        class="pb-0 pt-5 white" 
        :class="$vuetify.breakpoint.mdAndUp?'pl-4 pr-0 d-flex flex-md-column space-between align-end':'pt-4 px-6'"
        
      >
        <slot name="leftPanel" />
      </v-col>

      <!-- CONTENT PANEL-->
      <v-col id="maincon"
        cols="12" md="9" :lg="wideMainPanel ? 10 : 7" 
        :class="wideMainPanel? 'px-6 pt-5 pb-10 white':'px-6 pt-5 pb-10 white d-flex justify-md-center'"
        :style="$vuetify.breakpoint.mdAndUp?'min-height:650px;':''"
      ><!-- pl-lg-10 pl-xl-16 -->
        <v-sheet 
          :max-width="wideMainPanel ? '1500px' : '850px'" width="100%" min-height="250px"
        >
          <slot name="mainPanel" />
        </v-sheet>
      </v-col>

      <!-- RIGHT PANEL -->
      <v-col id="rside"
        v-if="!!this.$slots.rightPanel"
        cols="12" md="12" lg="3"
        class="px-6 pt-5 pb-4 d-print-none"
      >
        <v-row no-gutters>
          <!-- SPACER -->
          <v-col v-if="$vuetify.breakpoint.md" cols="3" />
          <v-col class="pl-0 pt-0">
            <v-row class="mb-3" v-if="$vuetify.breakpoint.mdAndDown" no-gutters> 
              <v-col class="pt-0">
                <h3 class="navlink--text text-h3">{{$t('database.rsidetitle')}}</h3>
              </v-col>
            </v-row>
            <v-row class="mb-3" no-gutters>
              <v-col class="pt-0 d-flex flex-row flex-lg-column flex-wrap" >
                <slot name="rightPanel" />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- BOTTOM PANEL (For extra stuff, e.g CTA banners at dono pages) -->
    <slot name="bottomPanel" />
  </div>
</template>

<script>
  import BreadCrumb from '@/components/applayout/Breadcrumb.vue'
  export default {
    name: 'ThreeColumn',
    components: {
      BreadCrumb
    },
    props: {
      breadcrumbPaths: {type: Array, default: () => []},
      wideMainPanel: {type: Boolean, default: false}  // no space for right panel for any screen size
    }
  }
</script>
